import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Slider from 'react-slick';
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

const Services = () => {
  const [config, setConfig] = useState({ base_image_url_2025: '' });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // mobile breakpoint

  useEffect(() => {
    fetch('/config.json')
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error('Error fetching config:', err));
  }, []);

  const images = [
    `${config.base_image_url_2025}/home/home-images/10.webp`,
    `${config.base_image_url_2025}/home/home-images/banner4.jpg`,
    `${config.base_image_url_2025}/home/home-images/banner3.jpg`,
    `${config.base_image_url_2025}/home/home-images/banner1.jpg`,
    `${config.base_image_url_2025}/home/home-images/3.jpg`,
    `${config.base_image_url_2025}/home/home-images/4.jpg`,
    `${config.base_image_url_2025}/home/home-images/5.jpg`,
    `${config.base_image_url_2025}/home/home-images/6.jpg`,
    `${config.base_image_url_2025}/home/home-images/banner2.jpg`,
    `${config.base_image_url_2025}/home/home-images/2.jpg`,
    `${config.base_image_url_2025}/home/home-images/7.jpg`,
    `${config.base_image_url_2025}/home/home-images/8.jpg`,
    `${config.base_image_url_2025}/home/home-images/9.jpg`,
  ];

  const ArrowStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 40,
    color: '#fff',
    cursor: 'pointer',
    zIndex: 2,
    transition: 'opacity 0.3s',
    opacity: isMobile ? 1 : 0, // always visible on mobile
  };

  const NextArrow = ({ onClick }) => (
    <ArrowForwardIos
      onClick={onClick}
      sx={{ ...ArrowStyle, right: 10 }}
      className="slider-arrow"
    />
  );

  const PrevArrow = ({ onClick }) => (
    <ArrowBackIos
      onClick={onClick}
      sx={{ ...ArrowStyle, left: 10 }}
      className="slider-arrow"
    />
  );

  const sliderSettings = {
    dots: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    pauseOnHover: false,
  };

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
        '&:hover .slider-arrow': { opacity: isMobile ? 1 : 1 }, // desktop hover effect
      }}
    >
      <Slider {...sliderSettings}>
        {images.map((src, idx) => (
          <Box key={idx} sx={{ width: '100%' }}>
            <Card
              sx={{
                width: '100%',
                aspectRatio: '16/9',
                borderRadius: 0,
                overflow: 'hidden',
              }}
            >
              <CardMedia
                component="img"
                src={src}
                alt={`Event ${idx + 1}`}
                sx={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  display: 'block',
                }}
              />
            </Card>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default Services;
